import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { DayOfWeekEx, ListItem, Meeting, RepositoryModal, User } from '../../shared'

@Component({
    templateUrl: './meeting.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class MeetingComponent extends RepositoryModal<Meeting> implements OnInit {
    boolMap: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]
    users: User[] = []
    dayOfWeekList = DayOfWeekEx.ToListItems()

    ngOnInit() {
        if (this.isAdding) {
            this.target.isActive = true
        }
        this.users = this.services.data.users.items.filter(x => x.active).slice()
        this.users.forEach(x => {
            if (this.target.userIds.indexOf(x.id) > -1) x['checked'] = true
            else x['checked'] = false
        })
    }

    protected onBeforeSave() {
        this.target.userIds = this.users.filter(x => x['checked']).map(x => x.id)
        return super.onBeforeSave()
    }
}
